"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyServiceLive = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const HttpProvider_1 = require("../utils/HttpProvider");
class CompanyServiceLive {
    async addPaymentMethod(companyId, nameOnCard, cardNumber, expiry, cvv, isPaidPlan) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/add-payment-method`, {
            nameOnCard,
            cardNumber,
            expiry,
            cvv,
            isPaidPlan,
        });
        return response.data;
    }
    async addCompany(companyRequestBody) {
        const response = await HttpProvider_1.httpProvider.post("/company", companyRequestBody);
        return response.data;
    }
    async setSelectedPlan(companyId, selectedPlanId) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}`, {
            selectedPlanId,
        });
        return response.data;
    }
    async cancelCompanyCreation(companyId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}`);
        return response.data;
    }
    async updateLastAccess(companyId) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/last-access`);
        return response.data;
    }
    async updateCompanyAuthorizationDetails(updateCompanyAuthorizationDetailsBody) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${updateCompanyAuthorizationDetailsBody.companyId}/authorize-mystake`, updateCompanyAuthorizationDetailsBody);
        return response.data;
    }
    async getCompanies(search = "", active = false) {
        try {
            const response = (await HttpProvider_1.httpProvider.get(`/company?search=${search}&active=${active}`));
            return {
                status: response.data.status,
                message: response.data.message,
                payload: response.data.payload,
            };
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: [],
            };
        }
    }
    async getCompanyInfo(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/info`);
        return response.data;
    }
    async getCompanyByAcn(acn) {
        const response = await HttpProvider_1.httpProvider.get(`/company/acn/${acn}`);
        return response.data;
    }
    async getAdminInfo(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/admin`);
        return response.data;
    }
    async updateAuthorizer(companyId, nomineeRequest) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/authorize-nominee`, nomineeRequest);
        return response.data;
    }
    async unsetKYCAuthorizationDetails(companyId) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/unset-kyc-authorization`);
        return response.data;
    }
    async getCompanyRegister(companyId, keyword, activeClassId, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/register?keyword=${keyword}&activeClassId=${activeClassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
        return response.data;
    }
    async getShareholderDetails(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-detail/${shareholderId}`);
        return response.data;
    }
    async getShareholder(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}`);
        return response.data;
    }
    async getAllTransactions(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/transactions`);
        return response.data;
    }
    async getShareholderBankDetails(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/bank-details`);
        return response.data;
    }
    async getFatcaCrsExport(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fatca-crs-export`);
        return response.data;
    }
    async getAllTransactionsByShareholderId(companyId, shareholderId, // share holder identification number
    sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-detail/${shareholderId}/transactions?sortBy=${sortBy}&sortOrder=${sortOrder}`);
        return response.data;
    }
    async getUnitIssueStatement(companyId, shareholderId, transactionId, timestamp) {
        const queryString = timestamp !== undefined ? `?timestamp=${timestamp}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/transactions/${transactionId}/unit-issue-statement${queryString}`);
        return response.data;
    }
    async issueSharesToNewShareholder(companyId, shareholder) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder`, shareholder);
        return response.data;
    }
    async createInvestorProfile(companyId, shareholder) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/investors`, shareholder);
        return response.data;
    }
    async getInvestorProfileDraft(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-profile-draft`);
        return response.data;
    }
    async saveInvestorProfileDraft(companyId, draft) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/investor-profile-draft`, draft);
        return response.data;
    }
    async clearInvestorProfileDraft(companyId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/investor-profile-draft`);
        return response.data;
    }
    async updateInvestorProfile(companyId, shareholder, overrides) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/investors/${shareholder._id}/update`, {
            shareholder,
            overrides,
        });
        return response.data;
    }
    async cloneInvestorRequests(targetCompanyId, investors) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${targetCompanyId}/clone-investors`, { investors });
        return response.data;
    }
    async updateShareholder(companyId, shareholderId, shareholder) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/update`, shareholder);
        return response.data;
    }
    async getSharePriceHistory(companyId, sortBy, sortOrder, filterByShareClass) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-price-history?sortBy=${sortBy}&sortOrder=${sortOrder}&filterByShareClass=${filterByShareClass}`);
        return response.data;
    }
    async createNewShareClass(companyId, createNewShareClassData) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/share-class`, createNewShareClassData);
        return response.data;
    }
    async getShareStructure(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-structure`);
        return response.data;
    }
    async getShareCapitalStructure(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-capital-structure`);
        return response.data;
    }
    async getCapitalStructureAndRegisterDifference(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/capital-structure-register-difference`);
        return response.data;
    }
    async isCapitalStructureAndRegisterDifferent(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/is-capital-structure-register-different`);
        return response.data.payload;
    }
    async setSharePrice(companyId, shareClassId, setSharePriceRequestBody) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/share-class/${shareClassId}/price`, setSharePriceRequestBody);
        return response.data;
    }
    async getYieldConfig(companyId, shareClassId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-class/${shareClassId}/yield-config`);
        return response.data;
    }
    async getAccrualRates(companyId, shareClassId, asAt) {
        const query = asAt ? `?asAt=${encodeURIComponent(asAt)}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-class/${shareClassId}/accrual-rates${query}`);
        return response.data;
    }
    async appendAccrualRate(companyId, shareClassId, rate) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/accrual-rates`, rate);
        return response.data;
    }
    async getAccrualRuns(companyId, shareClassId, from, to) {
        const window = [from && `from=${encodeURIComponent(from)}`, to && `to=${encodeURIComponent(to)}`].filter(Boolean);
        const query = window.length ? `?${window.join("&")}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-class/${shareClassId}/accrual-runs${query}`);
        return response.data;
    }
    async getPendingAccrualMints(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/accrual/pending-mints`);
        return response.data;
    }
    async claimAccrualMint(companyId, shareClassId, wallet) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/accrual/pending-mints/${shareClassId}/claims`, {
            wallet,
        });
        return response.data;
    }
    async reportAccrualMintSubmitted(companyId, shareClassId, claimId, batchIndex, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/accrual/pending-mints/${shareClassId}/claims/${claimId}/batches/${batchIndex}/submitted`, { txHash });
        return response.data;
    }
    async reportAccrualMintOutcome(companyId, shareClassId, claimId, batchIndex, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/accrual/pending-mints/${shareClassId}/claims/${claimId}/batches/${batchIndex}/outcome`, { txHash });
        return response.data;
    }
    async releaseAccrualMint(companyId, shareClassId, claimId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/accrual/pending-mints/${shareClassId}/claims/${claimId}`);
        return response.data;
    }
    async settleOpeningMintAccruals(companyId, shareClassId, movementIds) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/accrual/opening-mints/${shareClassId}`, {
            movementIds,
        });
        return response.data;
    }
    async getAccruedUnitsAsAt(companyId, shareholderId, shareClassId, asAt) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/share-class/${shareClassId}/accrued-units?asAt=${encodeURIComponent(asAt)}`);
        return response.data;
    }
    async getAccruedUnitsInWindow(companyId, shareholderId, shareClassId, from, to) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/share-class/${shareClassId}/accrued-units?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`);
        return response.data;
    }
    async getAccrualSettings(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/accrual-settings`);
        return response.data;
    }
    async updateAccrualSettings(companyId, settings) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/accrual-settings`, settings);
        return response.data;
    }
    async createShareClassRwaTokenWalletProofChallenge(companyId, shareClassId, ownerWalletAddress) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/rwa-token/wallet-proof-challenge`, { ownerWalletAddress });
        return response.data;
    }
    async deployShareClassRwaToken(companyId, shareClassId, ownerWalletAddress, proof) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/rwa-token`, {
            ownerWalletAddress,
            ...(proof?.challengeId ? { challengeId: proof.challengeId } : {}),
            ...(proof?.signature ? { signature: proof.signature } : {}),
        });
        return response.data;
    }
    async confirmShareClassIdentityStorageLink(companyId, shareClassId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/rwa-token/identity-storage-link`, {});
        return response.data;
    }
    async getAdminViewInfo(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/admin-view`);
        return response.data;
    }
    async getCompanyInformationPageData(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/information`);
        return response.data;
    }
    async getAdminList(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/admin-list`);
        return response.data;
    }
    async addNewAdmin(companyId, addNewAdminRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/create-admin`, addNewAdminRequestBody);
        return response.data;
    }
    async resendAdminInvite(companyId, adminUserId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/admin/${adminUserId}/resend-invite`);
        return response.data;
    }
    async removeAdmin(companyId, adminUserId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/admin/${adminUserId}`);
        return response.data;
    }
    async updateAdminWalletAddress(companyId, userId, walletAddress) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/admin/${userId}/wallet-address`, {
            walletAddress,
        });
        return response.data;
    }
    async getShareholders(companyId, keyword = "", excludeShareholderId = "") {
        try {
            const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder?keyword=${keyword}&excludeShareholderId=${excludeShareholderId}`);
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: [],
            };
        }
    }
    async getShareholdersV2(companyId, keyword = "") {
        try {
            const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/getShareholders/getShareholdersV2?keyword=${encodeURIComponent(keyword)}`);
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: [],
            };
        }
    }
    async getShareholdersByTypeAndShareClass(companyId, keyword, shareClassId, investorTypes, sortBy, sortOrder, page, rowsPerPage, sharesInputType, maxSharesTradable, deniedShareholders, activeStatus, auctionShareholderIds) {
        try {
            const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/getShareholders/getShareholdersByTypeAndShareClass`, {
                keyword,
                shareClassId,
                investorTypes,
                sortBy,
                sortOrder,
                page,
                rowsPerPage,
                sharesInputType,
                maxSharesTradable,
                deniedShareholders,
                activeStatus,
                auctionShareholderIds,
            });
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: { shareholders: [], count: 0, allShareholders: [] },
            };
        }
    }
    async issueSharesToExistingShareholder(companyId, shareholderId, payload) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/shareholder/${shareholderId}`, payload);
        return response.data;
    }
    async transferSharesToExistingShareholder(companyId, fromShareholderId, toShareholderId, payload) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/shareholder/${fromShareholderId}/to/${toShareholderId}/transfer`, payload);
        return response.data;
    }
    async transferSharesToNewShareholder(companyId, fromShareholderId, shareholder) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${fromShareholderId}/transfer`, shareholder);
        return response.data;
    }
    async updateRegisteredAddress(companyId, newRegisteredAddressData, authorisingOfficer) {
        if (newRegisteredAddressData) {
            const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/registered-address`, {
                careOf: newRegisteredAddressData.careOf,
                line2: newRegisteredAddressData.line2,
                street: newRegisteredAddressData.street,
                locality: newRegisteredAddressData.locality,
                state: newRegisteredAddressData.state,
                postcode: newRegisteredAddressData.postcode,
                country: newRegisteredAddressData.country,
                authorisingOfficer,
            });
            return response.data.status;
        }
        return false;
    }
    async updatePrincipalPlaceOfBusinessAddress(companyId, newPrincipalPlaceOfBusinessAddressData, authorisingOfficer) {
        if (newPrincipalPlaceOfBusinessAddressData) {
            const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/principal-place-of-business-address`, {
                careOf: newPrincipalPlaceOfBusinessAddressData.careOf,
                line2: newPrincipalPlaceOfBusinessAddressData.line2,
                street: newPrincipalPlaceOfBusinessAddressData.street,
                locality: newPrincipalPlaceOfBusinessAddressData.locality,
                state: newPrincipalPlaceOfBusinessAddressData.state,
                postcode: newPrincipalPlaceOfBusinessAddressData.postcode,
                country: newPrincipalPlaceOfBusinessAddressData.country,
                authorisingOfficer,
            });
            return response.data.status;
        }
        return false;
    }
    async importCSV(companyId, csvFile, options) {
        const formData = new FormData();
        formData.append("csv", csvFile, csvFile.name);
        const confirmQuery = options?.confirm ? "?confirm=true" : "";
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/import-csv${confirmQuery}`, formData);
        return response.data;
    }
    async createNewAdminAccount(adminUserId, companyId, createNewAdminAccountRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/admin/${adminUserId}`, createNewAdminAccountRequestBody);
        const customToken = response.data.payload;
        return {
            status: true,
            message: "Account creation successful",
            payload: customToken,
        };
    }
    async getInvestorInvitations(companyId, keyword, page, rowsPerPage, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/invitations?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}`);
        return response.data;
    }
    async activateAsicConnection(companyId) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/activate-asic`);
        return response.data;
    }
    async getAsicConnectionStatus(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/asic-status`);
        return response.data.payload;
    }
    async getCas360ConnectionStatus(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/cas360-status`);
        return response.data.payload;
    }
    async getBgl360AuthoriseUrl(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/bgl360-authorise-url`);
        return response.data;
    }
    async bglResync(companyId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/bgl-resync`);
        return response.data;
    }
    async updateAsicData(companyId, adminUserId) {
        const reqData = { companyId, adminUserId };
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/update-asic`, reqData);
        return response.data;
    }
    async generateHoldingStatement(companyId, shareholderId, startDate, endDate, timestamp) {
        try {
            const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/holding-statement?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&timestamp=${encodeURIComponent(timestamp)}`);
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: null,
            };
        }
    }
    async generateAccrualStatement(companyId, shareholderId, shareClassId, from, to) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/share-class/${shareClassId}/accrual-statement?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`);
        return response.data;
    }
    async getCompanyPlanInfo(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/plan-info`);
        return response.data;
    }
    async inviteNewShareholder(companyId, inviteNewShareholderRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/invite-shareholder`, inviteNewShareholderRequestBody);
        return response.data;
    }
    async inviteInvestorByDetails(companyId, inviteInvestorByDetailsRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/invite-investor-by-details`, inviteInvestorByDetailsRequestBody);
        return response.data;
    }
    async inviteOwnerContact(companyId, shareholderId, ownerIndex) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/owner-contact/invite`, { ownerIndex });
        return response.data;
    }
    async getStripeCustomerPortalUrl(companyId, returnPage) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/stripe-customer-portal${returnPage ? `?returnPage=${returnPage}` : ""}`);
        return response.data;
    }
    async getActivityLogs(companyId, sortBy, sortOrder, skip, limit) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/activity-logs?sortBy=${sortBy}&sortOrder=${sortOrder}&skip=${skip}&limit=${limit}`);
        return response.data;
    }
    async getInvestorContacts(companyId, keyword, page, rowsPerPage, sortOrder, sortBy) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/contacts?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
        return response.data;
    }
    async getAllContacts(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-relations/contacts/all`);
        return response.data;
    }
    async createAnnouncement(companyId, createAnnouncementRequestBody) {
        const formData = new FormData();
        formData.append("subject", createAnnouncementRequestBody.subject);
        formData.append("body", createAnnouncementRequestBody.body);
        formData.append("includeShareholders", createAnnouncementRequestBody.includeShareholders.toString());
        formData.append("includeNoteholders", createAnnouncementRequestBody.includeNoteholders.toString());
        formData.append("includeOptionholders", createAnnouncementRequestBody.includeOptionholders.toString());
        createAnnouncementRequestBody.selectedShareClassIds?.forEach((shareClassId) => {
            formData.append("selectedShareClassIds", shareClassId);
        });
        // files is File[] | null — attachments are optional, so guard against Array.from(null) throwing.
        Array.from(createAnnouncementRequestBody.files ?? []).forEach((file) => {
            formData.append("files", file, file.name);
        });
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/announcement`, formData);
        return response.data;
    }
    async uploadDocument(companyId, uploadedByUserId, pdfFile, shareholderId, expiryDate, documentType) {
        const formData = new FormData();
        formData.append("pdf", pdfFile, pdfFile?.name);
        if (shareholderId) {
            formData.append("shareholderId", shareholderId);
        }
        if (expiryDate) {
            formData.append("expiryDate", expiryDate.toISOString());
        }
        if (documentType) {
            formData.append("documentType", documentType);
        }
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/upload-document/${uploadedByUserId}`, formData);
        return response.data;
    }
    async deleteDocument(companyId, documentId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/documents/${documentId}`);
        if (!response.data?.status) {
            throw new Error(response.data?.message || "Failed to delete document");
        }
        return response.data;
    }
    async getInvestorApplicationDocuments(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-application-documents`);
        return response.data;
    }
    async getCompanyDocuments(companyId, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/documents?page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
        return response.data;
    }
    async getShareholderDocuments(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/documents/${shareholderId}`);
        return response.data;
    }
    async getAdminOnlyShareholderDocuments(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/admin-only-documents/${shareholderId}`);
        return response.data;
    }
    async uploadAdminOnlyDocument(companyId, uploadedByUserId, pdfFile, shareholderId) {
        const formData = new FormData();
        formData.append("pdf", pdfFile, pdfFile?.name);
        formData.append("shareholderId", shareholderId);
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/upload-admin-only-document/${uploadedByUserId}`, formData);
        return response.data;
    }
    async deleteAdminOnlyDocument(companyId, documentId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/admin-only-documents/${documentId}`);
        if (!response.data?.status) {
            throw new Error(response.data?.message || "Failed to delete admin-only document");
        }
        return response.data;
    }
    async getSignedUrlOfDocument(companyId, documentId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/document/${documentId}`);
        return response.data;
    }
    async uploadCompanyLogo(companyId, logoFile) {
        // create form data
        const formData = new FormData();
        formData.append("logo", logoFile, logoFile.name);
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/logo`, formData);
        return response.data;
    }
    async setCompanyDisplayName(companyId, name) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/display-name`, { name });
        return response.data;
    }
    async getDistributionSettings(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/distribution-settings`);
        return response.data;
    }
    async updateDistributionSettings(companyId, config) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/distribution-settings`, config);
        return response.data;
    }
    async getBankAccounts(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/bank-accounts`);
        return response.data;
    }
    async updateBankAccounts(companyId, update) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/bank-accounts`, update);
        return response.data;
    }
    async getActivityNotificationConfig(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/activity-notifications`);
        return response.data;
    }
    async updateActivityNotificationConfig(companyId, config) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/activity-notifications`, config);
        return response.data;
    }
    async updateWholesaleVerification(companyId, shareholderId, verification) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/shareholder/${shareholderId}/wholesale-verification`, verification);
        return response.data;
    }
    async getInvestorApplicationConfig(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-application-config`);
        return response.data;
    }
    async updateInvestorApplicationConfig(companyId, config) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/investor-application-config`, config);
        return response.data;
    }
    async updateProtocolSettings(companyId, settings) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/protocol-settings`, settings);
        return response.data;
    }
    async listApiCredentials(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/api-credentials`);
        return response.data;
    }
    async registerApiCredential(companyId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/api-credentials`, {});
        return response.data;
    }
    async revokeApiCredential(companyId, credentialId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/api-credentials/${credentialId}`);
        return response.data;
    }
    async getUnitTransferStatement(companyId, shareholderId, transferId, timestamp) {
        const queryString = timestamp !== undefined ? `?timestamp=${timestamp}` : "";
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/transfers/${transferId}/unit-transfer-statement${queryString}`);
        return response.data;
    }
    async deleteTransactionsOfShareholder(companyId, shareholderIds) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/transactions/`, { shareholderIds });
        return response.data;
    }
    async deleteTransactionsOfACompany(companyId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/transactions/all`);
        return response.data;
    }
    async getOfficeholders(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/appointments`);
        return response.data;
    }
    async getOfficeholderById(companyId, officeholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/appointments/${officeholderId}`);
        return response.data;
    }
    async appointOfficeholder(companyId, appointOfficeholderRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/appointments`, appointOfficeholderRequestBody);
        return response.data;
    }
    async updateOfficeholder(companyId, officeholderId, editOfficeholderRequestBody) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/appointments/${officeholderId}`, editOfficeholderRequestBody);
        return response.data;
    }
    async removeOfficeholders(companyId, removeOfficeholdersRequestBody) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/appointments`, removeOfficeholdersRequestBody);
        return response.data;
    }
    async createNewNotes(companyId, createNotesData) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/notes`, createNotesData);
        return response.data;
    }
    async getAllNotes(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/notes`);
        return response.data;
    }
    async issueNotesToExistingShareholder(companyId, shareholderId, transaction) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/notes/${shareholderId}`, transaction);
        return response.data;
    }
    async issueNotesToNewShareholder(companyId, shareholder) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/notes`, shareholder);
        return response.data;
    }
    async getNotesRegister(companyId, keyword, activeClassId, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/register/notes?keyword=${keyword}&activeClassId=${activeClassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
        return response.data;
    }
    async getExpiringKycRegister(companyId, keyword, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/register/expiring-kyc?keyword=${encodeURIComponent(keyword)}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
        return response.data;
    }
    async getNotesCsvData(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/register/notes/csv`);
        return response.data;
    }
    async deleteNote(companyId, noteId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/notes/${noteId}`);
        return response.data;
    }
    async getNotesNamesAndCodes(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/notes/names-and-codes`);
        return response.data;
    }
    async getOptionGrantDetailsByShareholderId(companyId, shareholderId, optiongrantId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/options/grant-detail/${optiongrantId}`);
        return response.data;
    }
    async getOptionUnitsDetailsByGrantId(companyId, shareholderId, optiongrantId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/options/grant-detail-units/${optiongrantId}`);
        return response.data;
    }
    async getNoteDetailsByShareholderId(companyId, shareholderId, notetransactionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investor-detail/${shareholderId}/notes/${notetransactionId}`);
        return response.data;
    }
    async createNewOptionsPool(companyId, createNewOptionsPoolData) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/option-pool`, createNewOptionsPoolData);
        return response.data;
    }
    async updateOptionsPool(companyId, optionsPoolId, updateOptionsPoolData) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/option-pool/${optionsPoolId}`, updateOptionsPoolData);
        return response.data;
    }
    async convertNotes(companyId, shareholderId, notesTransactionId, transaction) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/investor-detail/${shareholderId}/notes-convert/${notesTransactionId}`, transaction);
        return response.data;
    }
    async removeOptionsPool(companyId, optionsPoolId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-pool/${optionsPoolId}`);
        return response.data;
    }
    async getOptionPoolNames(companyId, type) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/option-pool?type=${type}`);
        return response.data;
    }
    async getOptionPools(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/option-pool/all`);
        return response.data;
    }
    async createNewOptionGrant(companyId, optionGrantData) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/option-grant`, optionGrantData);
        return response.data;
    }
    createOptionUnit(companyId, optionUnitData) {
        return HttpProvider_1.httpProvider.post(`/company/${companyId}/option-unit/create`, optionUnitData).then((res) => res.data);
    }
    deleteOptionUnit(companyId, optionUnitId) {
        return HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-unit/${optionUnitId}/delete`).then((res) => res.data);
    }
    getOptionRegisterForOptionholder(companyId, optionholderId) {
        return HttpProvider_1.httpProvider.get(`/company/${companyId}/option-register/${optionholderId}`).then((res) => res.data);
    }
    getOptionRegister(companyId, search, shareclassId, sortBy, sortOrder, page, rowsPerPage) {
        return HttpProvider_1.httpProvider
            .get(`/company/${companyId}/option-register?search=${search}&shareclassId=${shareclassId}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`)
            .then((res) => res.data);
    }
    async getOptionsCsvData(companyId) {
        return HttpProvider_1.httpProvider.get(`/company/${companyId}/option-register/csv`).then((res) => res.data);
    }
    async getOptionPoolNamesAndCodes(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/options/names-and-codes`);
        return response.data;
    }
    async exerciseOptions(companyId, optionGrantId, exerciseData) {
        return HttpProvider_1.httpProvider
            .post(`/company/${companyId}/option-grant/${optionGrantId}/exercise`, { exerciseData })
            .then((res) => res.data);
    }
    async updateGrant(companyId, optionGrantId, updateData) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/option-grant/${optionGrantId}/update`, updateData);
        return response.data;
    }
    async deleteGrant(companyId, optionGrantId) {
        const response = await HttpProvider_1.httpProvider.delete(`/company/${companyId}/option-grant/${optionGrantId}/delete`);
        return response.data;
    }
    async createNewFundraise(companyId, createFundraiseData) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/fundraises`, createFundraiseData);
        return response.data;
    }
    async paySubscriptionAgreement(companyId, paySubscriptionAgreementRequestBody) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/payment-details`, paySubscriptionAgreementRequestBody);
        return response.data;
    }
    async getFundraiseByFundraiseId(companyId, fundraiseId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraises/${fundraiseId}`);
        return response.data;
    }
    async generateReconciliationReport(companyId, fundraiseRound, timestamp) {
        try {
            const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fundraises/${fundraiseRound._id}/reconciliation-report?timestamp=${encodeURIComponent(timestamp)}`, fundraiseRound);
            return response.data;
        }
        catch (err) {
            return {
                status: false,
                message: err.message,
                payload: null,
            };
        }
    }
    async getHighestShareCertificateNumber(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/share-certificate-number`);
        return response.data;
    }
    async getFundraiseCsvDataByFundraiseId(companyId, fundraiseId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/fundraise/${fundraiseId}/csv`);
        return response.data;
    }
    async createFundraiseBankAccount(companyId, bankAccount) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/create-bank-account`, bankAccount);
        return response.data;
    }
    async updateCompanyClaimIssuerOnchainId(companyId, onchainId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/claim-issuer-onchain-id`, {
            onchainId,
        });
        return response.data;
    }
    async ensureInvestorOnchainId(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/investors/${shareholderId}/onchainid`);
        return response.data;
    }
    async createInvestorOnchainIdWalletProofChallenge(companyId, ownerWalletAddress) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/investor-onchain-id/wallet-proof-challenge`, {
            ownerWalletAddress,
        });
        return response.data;
    }
    async ensureCompanyInvestorOnchainId(companyId, managerAddress, challengeId, signature) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/investor-onchain-id`, {
            managerAddress,
            challengeId,
            signature,
        });
        return response.data;
    }
    async getVaultSetup(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/vault-setup`);
        return response.data;
    }
    async createFundSet(companyId, signature, deadline) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/fund-set`, { signature, deadline });
        return response.data;
    }
    async saveVaultSet(companyId, shareClassId, stablecoinAddress, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/vault-set`, {
            stablecoinAddress,
            txHash,
        });
        return response.data;
    }
    async recordVaultOperation(companyId, shareClassId, txHash, proof) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/share-class/${shareClassId}/vault-operation`, {
            txHash,
            ...proof,
        });
        return response.data;
    }
    async getAllInvestors(companyId, keyword, page, rowsPerPage, sortBy, sortOrder, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED]) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/investors?keyword=${keyword}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}&status=${status}`);
        return response.data;
    }
    async getShareholderTransactionsByAuctionId({ companyId, shareholderId, auctionId, sortBy, sortOrder, page, rowsPerPage, phase = "All", }) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/auction-transactions/${shareholderId}/${auctionId}?sortBy=${sortBy}&sortOrder=${sortOrder}&page=${page}&rowsPerPage=${rowsPerPage}&phase=${phase}`);
        return response.data;
    }
    async updateCompanyContactEmail(companyId, email) {
        const response = await HttpProvider_1.httpProvider.patch(`/company/${companyId}/update-contact-email`, { email });
        return response.data;
    }
    async setLiquidityProvider(companyId, { shareholderId, }) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/set-liquidity-provider`, {
            shareholderId,
        });
        return response.data;
    }
    async getLiquidityProvider(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/get-liquidity-provider`);
        return response.data;
    }
    async requestActOnBehalf(companyId, shareholderId, contactId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/contacts/${contactId}/act-on-behalf/request`);
        return response.data;
    }
    async approveActOnBehalf(companyId, shareholderId, contactId, kyc) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/contacts/${contactId}/act-on-behalf/approve`, kyc);
        return response.data;
    }
    async declineActOnBehalf(companyId, shareholderId, contactId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/contacts/${contactId}/act-on-behalf/decline`);
        return response.data;
    }
    async revokeActOnBehalf(companyId, shareholderId, contactId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/contacts/${contactId}/act-on-behalf/revoke`);
        return response.data;
    }
    async getActOnBehalfRequests(companyId, page, rowsPerPage) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/register/act-on-behalf-requests?page=${page}&rowsPerPage=${rowsPerPage}`);
        return response.data;
    }
    async getTrustees(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholder/${shareholderId}/trustees`);
        return response.data;
    }
    async inviteTrustee(companyId, shareholderId, trusteeId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholder/${shareholderId}/trustees/${trusteeId}/invite`);
        return response.data;
    }
}
exports.CompanyServiceLive = CompanyServiceLive;
//# sourceMappingURL=CompanyServiceLive.js.map